<template>
  <div class="container">
    <my-nav-ui :idx="4"></my-nav-ui>
    <div class="bottom">
      <div class="right">
        <my-echarts-map-ui :mapId="12"></my-echarts-map-ui>
      </div>
    </div>
    <div class="tip">
      <div>
        <ul>
          <li>
            <img src="../assets/mark_0.png" />
          </li>
          <li>正常运行</li>
        </ul>
      </div>
      <div>
        <ul>
          <li>
            <img src="../assets/mark_1.png" />
          </li>
          <li>人工报警</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from '@/api/global_variable'
import chartsView4 from '@/api/charts_view4'
export default {
  name: 'EchartsView4',
  data() {
    return {
      loading: true,
      ViewData: null,
      deviceTotal: 0,
      Timer: null,
      echartsBar: null,
      echartsMap: null,
      cityName: '',
      sName: [],
      sData: []
    }
  },
  mounted() {
    if (!GLOBAL.isLogin()) {
      this.$router.push({ path: '/login' })
    } else {
      GLOBAL.curPage = 4
      chartsView4.setEcharts(this.$echarts)
      this.loading = false
      const cityName = sessionStorage.getItem('cityName')
      const cityId = sessionStorage.getItem('cityId')
      const regionType = sessionStorage.getItem('regionType')
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
           citytype: regionType,
          cityid: cityId,
        },
        methods: 'get',
        url:
          process.env.API_ROOT +
          '/Visual/item/byarea'
      }).then(res => {
        console.log(res)
        const list = res.data.result
        list.forEach(item => {
          this.sData.push(item.totalFixingCount)
          this.sName.push(item.groupName)
        })
        this.drawBar()
      })
      // this.cityName = cityName
      // if (cityName === '郴州市') {
      //   this.sData = GLOBAL.czData
      //   this.sName = GLOBAL.czName
      // } else if (cityName === '阜阳市') {
      //   this.sData = GLOBAL.fyData
      //   this.sName = GLOBAL.fyName
      // } else if (cityName === '临泉县') {
      //   this.sData = GLOBAL.lqData
      //   this.sName = GLOBAL.lqName
      // } else if (cityName === '邵阳市') {
      //   this.sData = GLOBAL.syData
      //   this.sName = GLOBAL.syName
      // } else if (cityName === '清远市') {
      //   this.sData = GLOBAL.qyData
      //   this.sName = GLOBAL.qyName
      // }

      // this.drawView1Charts1()
    }
  },
  beforeDestroy() {
    clearInterval(this.Timer)
    this.Timer = null
    if (this.echartsBar) {
      this.echartsBar.clear()
    }
  },
  created() {
    this.drawView1Charts1()
  },
  methods: {
    drawView1Charts1() {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId')
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/count'
      }).then(res => {
        this.deviceTotal = res.data.result
        // this.cityName = sessionStorage.getItem('cityName')
        // GLOBAL.totalData.forEach(item => {
        //   if (item.name == this.cityName) {
        //     this.deviceTotal = item.size
        //   }
        // })
      })
    },
    drawBar: function() {
      var option = {
        grid: {
          show: 'true',
          borderWidth: '0',
          height: '99%',
          width: '80%',
          x: '16%',
          y: 0
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b0}: {c0}'
          /* formatter: function(params) {
                var result = '';
                params.forEach(function (item) {
                    result += item.marker + " " + item.seriesName + " : " + item.value +"</br>";
                });
                return result;
            } */
        },
        xAxis: {
          show: false, // 是否显示x轴
          type: 'value'
        },
        yAxis: {
          type: 'category',
          inverse: true, // 让y轴数据逆向
          axisLabel: {
            show: true,
            textStyle: {
              color: '#666' // y轴字体颜色
            },
            formatter: function(value, index) {
              return ['{title|' + value + '} '].join('\n')
            },
            // 定义富文本标签
            rich: {
              lg: {
                fontWeight: 'bold',
                fontSize: 12, // 字体默认12
                color: '#08C',
                padding: [0, 5, 0, 0]
              },
              title: {
                color: '#fff',
                fontWeight: 'lighter'
                // borderWidth: 1,
                // borderColor: '#08c'
                // textareaBorderColor: '#08c',
              }
            }
          },
          splitLine: { show: false }, // 横向的线
          axisTick: { show: false }, // y轴的端点
          axisLine: { show: false }, // y轴的线
          data: this.sName
        },
        series: [
          {
            name: '数据内框',
            type: 'bar',
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: '#00b5eb'
              }
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                color: '#fff',
                fontSize: 14,
                formatter: function(param) {
                  // return 'xx';
                }
              }
            },
            barWidth: 30,
            data: this.sData
          },
          {
            name: '外框',
            type: 'bar',
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: 'rgba(255, 255, 255, 0.14)' // rgba设置透明度0.14
              }
            },
            barGap: '-100%',
            z: 0,
            barWidth: 30,
            data: [
              5000,
              5000,
              5000,
              5000,
              5000,
              5000,
              5000,
              5000,
              5000,
              5000,
              5000
            ]
          }
        ]
      }

      this.echartsBar = this.$echarts.init(document.getElementById('leftBar'))
      this.echartsBar.setOption(option)
    }
  }
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
ul {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0;
}
li {
  list-style: none;
}
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}

.bottom {
  height: calc(100% - 110px);
  height: -webkit-calc(100% - 110px);
  height: -moz-calc(100% - 110px); 
  width: 90%;
  display: inline-flex;
}
.bottom .left {
  width: 34%;
  background: #121d49;
  border-radius: 6px;
  height: 80%;
  max-height: 700px;
  margin-top: 90px;
  margin-left: 10%;
}
.bottom .left .left-title {
  width: 100%;
  height: 60px;
}
.bottom .left .left-title > ul > li {
  float: left;
  text-align: center;
  color: #7cb0ff;
  font-size: 16px;
  height: 100%;
  line-height: 60px;
}
.bottom .left .left-title > ul > li:first-child {
  width: 30px;
  margin-left: 60px;
  padding-top: 4px;
  text-align: center;
  vertical-align: middle;
}

.bottom .left .left-title > ul > li > img {
  width: 18px;
  height: 18px;
}

.bottom .left .left-title > ul > li:last-child {
  color: #75e1eb;
  margin-left: 1px;
}
.bottom .left > div:first-child {
  height: 50px;
  line-height: 50px;
  width: 100%;
  text-align: left;
  font-size: 20px;
}

.bottom .left > div:last-child {
  height: 90%;
  background: #121d49 !important;
  width: 98%;
  margin: 0 auto;
}

.bottom .right {
  width: 100%;
  height: 100%;
}

.tip {
  width: 140px;
  height: 70px;
  position: absolute;
  bottom: 100px;
  right: 100px;
}

.tip > div {
  width: 100%;
  height: 30px;
  background: #121d49;
  border-radius: 6px;
  border: 1px solid #43bcff;
}

.tip > div:first-child {
  margin-bottom: 10px;
}

.tip > div > ul > li {
  float: left;
  width: 60%;
  text-align: left;
  font-size: 12px;
  color: #a7c6d6;
  height: 30px;
  line-height: 30px;
}

.tip > div > ul > li:first-child {
  width: 40%;
  text-align: center;
}
.tip > div > ul > li > img {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/EchartsView4.vue